import React from "react";
import FlexBox from "view/components/Layout/FlexBox";
import {IconButton, Typography} from "@material-ui/core";
import SettingsIcon from "view/images/SettingsIcon";
import {blue, grey} from "@material-ui/core/colors";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import RequiredIcon from "view/components/GridResponseBlock/CustomizeTable/Components/Rows/Cell/RequiredIcon";
import useStyles from "./styles";

type TextInputProps = {
  isRequired: boolean;
  isActive: boolean;
  onClickSettings: () => void;
  onClickMandatory: () => void;
  viewOnly?: boolean;
};

function OptionsInput({
  isRequired,
  isActive,
  onClickMandatory,
  onClickSettings,
  viewOnly,
}: TextInputProps) {
  const classes = useStyles();
  const shouldDisplayIcon = !viewOnly || isRequired;

  return (
    <FlexBox alignCenter gap={1} width="100%">
      <FlexBox
        className={classes.cellInput}
        justifyContent="space-between"
        alignCenter
      >
        <Typography className={classes.cellInputText}>Select option</Typography>
        <ArrowDropDownIcon width="16px" htmlColor={grey[400]} />
      </FlexBox>
      <FlexBox alignCenter gap={0.75}>
        {shouldDisplayIcon && (
          <RequiredIcon
            onClick={onClickMandatory}
            isRequired={isRequired}
            viewOnly={viewOnly}
          />
        )}
        {!viewOnly && (
          <IconButton className={classes.cellButton} onClick={onClickSettings}>
            <SettingsIcon fill={isActive ? blue.A100 : undefined} />
          </IconButton>
        )}
      </FlexBox>
    </FlexBox>
  );
}

export default OptionsInput;
